import * as Yup from 'yup';
import map from 'lodash.map';
import countryData from 'country-data';
import { lang } from 'moment';

const languages = countryData.languages?.all?.filter((lang) => lang.alpha2);

export const configTypes = {
  'basket-playground': {
    label: 'Basket Playground',
    fields: [
      {
        label: 'Config Label',
        type: 'text',
        dataType: 'string',
        name: 'configLabel',
        placeholder: 'Config Label',
        required: true,
      },
      {
        label: 'API Endpoint',
        type: 'text',
        dataType: 'string',
        name: 'api-endpoint',
        placeholder: 'API Endpoint',
        required: true,
      },

      {
        label: 'API Method Type',
        type: 'dropdown',
        dataType: 'string',
        name: 'api-method-type',
        placeholder: 'API Method Type',
        required: true,
        options: [
          {
            label: 'GET',
            value: 'GET',
          },
          {
            label: 'POST',
            value: 'POST',
          },
          {
            label: 'PUT',
            value: 'PUT',
          },
          {
            label: 'DELETE',
            value: 'DELETE',
          },
        ],
      },
      {
        label: 'API Type',
        type: 'dropdown',
        dataType: 'string',
        name: 'api-type',
        placeholder: 'API Type',
        required: true,
        options: [
          {
            label: '--SELECT--',
            value: '',
          },
          {
            label: 'GraphQL',
            value: 'GraphQL',
          },
          { label: 'REST', value: 'REST' },
        ],
      },
      {
        label: 'GQL Query',
        type: 'text',
        isParagraph: true,
        showWhen: (fieldValues) => {
          return fieldValues['api-type'] === 'GraphQL';
        },
        initialNumberOfLines: 5,
        dataType: 'string',
        name: 'gql-query',
        placeholder: 'Enter GQL Query',
        required: false,
      },

      {
        label: 'GQL Variable Structure',
        type: 'text',
        isParagraph: true,
        showWhen: (fieldValues) => {
          return fieldValues['api-type'] === 'GraphQL';
        },
        initialNumberOfLines: 5,
        dataType: 'string',
        name: 'gql-variables',
        placeholder: 'Enter GQL Variables',
        required: false,
      },
      {
        label: 'Product Name Field',
        type: 'text',
        dataType: 'string',
        name: 'product-name-field',
        placeholder: 'Enter a product name field',
        required: true,
      },
    ],
  },
  brands: {
    label: 'Brands',
    fields: [
      {
        label: 'Brand Name',
        type: 'text',
        dataType: 'string',
        name: 'configLabel',
        placeholder: 'Config Label',
        required: true,
      },
      {
        label: 'Brand Description',
        type: 'text',
        dataType: 'string',
        name: 'api-endpoint',
        placeholder: 'API Endpoint',
        required: true,
      },
    ],
  },
  languages: {
    label: 'Languages',
    fields: [
      {
        label: 'Language Name',
        type: 'dropdown',
        dataType: 'string',
        name: 'configLabel',
        placeholder: 'Enter Language Name',
        required: true,
        options: languages?.map(({ alpha2, name }) => ({
          label: name,
          value: alpha2,
        })),
        onChange: ({ value, formik }) => {
          formik.setFieldValue(
            'name',
            languages.find((lang) => lang.alpha2 === value).name
          );
          formik.setFieldValue('code', value);
        },
      },
      {
        label: 'Language Code',
        type: 'hidden',
        dataType: 'string',
        name: 'name',
        placeholder: 'Enter Language Name',
        required: true,
      },
      {
        label: 'Is Default Language',
        type: 'dropdown',

        dataType: 'boolean',
        name: 'isDefault',
        placeholder: '',
        required: true,
        options: [
          {
            label: 'No',
            value: 'no',
          },
          {
            label: 'Yes',
            value: 'yes',
          },
        ],
      },
      {
        label: 'Is Mandatory for Error Messages',
        type: 'dropdown',

        dataType: 'boolean',
        name: 'isMandatoryForErrorMessages',
        placeholder: '',
        required: false,
        options: [
          {
            label: 'No',
            value: 'no',
          },
          {
            label: 'Yes',
            value: 'yes',
          },
        ],
      },
    ],
  },
  members: {
    label: 'Members Standard Attributes',
    fields: [
      {
        label: 'Field Label',
        type: 'text',
        dataType: 'string',
        name: 'configLabel',
        placeholder: 'Enter Field Label',
        required: true,
      },
      {
        label: 'Field ID',
        type: 'text',
        dataType: 'string',
        name: 'fieldId',
        placeholder: 'Enter Field ID',
        required: true,
      },
      {
        label: 'Field Type',
        type: 'dropdown',
        dataType: 'string',
        name: 'fieldType',
        placeholder: 'Field Type',
        required: true,
        options: [
          {
            label: 'First Name',
            value: 'FirstName',
          },
          {
            label: 'Last Name',
            value: 'LastName',
          },
          {
            label: 'Email',
            value: 'Email',
          },
          {
            label: 'Email Verified',
            value: 'EmailVerified',
          },
          {
            label: 'Mobile Number',
            value: 'MobileNumber',
          },
          {
            label: 'Mobile Number Verified',
            value: 'MobileNumberVerified',
          },
          {
            label: 'Date of Birth',
            value: 'DateOfBirth',
          },
          {
            label: 'Joined Date',
            value: 'JoinedDate',
          },
          { label: 'Nationality', value: 'Nationality' },
          { label: 'Gender', value: 'Gender' },
          { label: 'Language', value: 'Language' },
          { label: 'Country', value: 'country' },
          { label: 'City', value: 'City' },
          { label: 'Profile Picture', value: 'ProfilePicture' },
          { label: 'First Visit Country', value: 'FirstVisitCountry' },
          { label: 'Last Visit Country', value: 'LastVisitCountry' },
          { label: 'First Visit Brand', value: 'FirstVisitBrand' },
          { label: 'Last Visit Brand', value: 'LastVisitBrand' },
          { label: 'First Visit Store', value: 'FirstVisitStore' },
          { label: 'Last Visit Store', value: 'LastVisitStore' },

          { label: 'First Purchase Date', value: 'FirstPurchaseDate' },
          { label: 'Last Purchase Date', value: 'LastPurchaseDate' },

          { label: 'Other Field', value: 'OtherField' },
        ],
      },
      {
        label: 'Is Primary Identifier',
        type: 'dropdown',
        dataType: 'boolean',
        name: 'isPrimaryIdentifier',
        placeholder: 'Is Primary Identifier',
        required: false,
        options: [
          {
            label: 'No',
            value: 'no',
          },
          {
            label: 'Yes',
            value: 'yes',
          },
        ],
      },
      {
        label: 'Is Loyalty Card Unique ID',
        type: 'dropdown',
        isParagraph: true,
        showWhen: (fieldValues) => {
          return (
            fieldValues['fieldType'] === 'OtherField' &&
            fieldValues['isPrimaryIdentifier'] === 'yes'
          );
        },
        initialNumberOfLines: 5,
        dataType: 'string',
        name: 'isLoyaltyCardUniqueID',
        placeholder: 'Is Loyalty Card Unique ID',
        required: false,
        options: [
          {
            label: 'No',
            value: 'no',
          },
          {
            label: 'Yes',
            value: 'yes',
          },
        ],
      },
      {
        label: 'Display In Profile',
        type: 'dropdown',
        isParagraph: true,
        showWhen: (fieldValues) => {
          return fieldValues['fieldType'] === 'OtherField';
        },
        initialNumberOfLines: 5,
        dataType: 'string',
        name: 'displayInProfile',
        placeholder: 'Display In Profile',
        required: false,
        options: [
          {
            label: 'No',
            value: 'no',
          },
          {
            label: 'Yes',
            value: 'yes',
          },
        ],
      },
      {
        label: 'Data Type',
        type: 'dropdown',
        isParagraph: true,
        showWhen: (fieldValues) => {
          return fieldValues['fieldType'] === 'OtherField';
        },
        initialNumberOfLines: 5,
        dataType: 'string',
        name: 'dataType',
        placeholder: 'Choose Data Type',
        required: false,
        options: [
          {
            label: 'String',
            value: 'String',
          },
          {
            label: 'Boolean',
            value: 'Boolean',
          },
          {
            label: 'Date',
            value: 'Date',
          },
          {
            label: 'DateTime',
            value: 'DateTime',
          },
        ],
      },
    ],
  },
  'members-localization': {
    label: 'Members Localization Attributes',
    fields: [
      {
        label: 'Field Label',
        type: 'text',
        dataType: 'string',
        name: 'configLabel',
        placeholder: 'Enter Field Label',
        required: true,
      },
      {
        label: 'Field ID',
        type: 'text',
        dataType: 'string',
        name: 'fieldId',
        placeholder: 'Enter Field ID',
        required: true,
      },
      {
        label: 'Field Type',
        type: 'dropdown',
        dataType: 'string',
        name: 'fieldType',
        placeholder: 'Field Type',
        required: true,
        options: [
          { label: 'First Seen Date', value: 'FirstSeenDate' },
          { label: 'First Visit Country', value: 'FirstVisitCountry' },
          { label: 'Last Visit Country', value: 'LastVisitCountry' },
          { label: 'First Visit Brand', value: 'FirstVisitBrand' },
          { label: 'Last Visit Brand', value: 'LastVisitBrand' },
          { label: 'First Visit Store', value: 'FirstVisitStore' },
          { label: 'Last Visit Store', value: 'LastVisitStore' },

          { label: 'First Purchase Date', value: 'FirstPurchaseDate' },
          { label: 'Last Purchase Date', value: 'LastPurchaseDate' },

          { label: 'Other Field', value: 'OtherField' },
        ],
      },

      {
        label: 'Data Type',
        type: 'dropdown',
        isParagraph: true,
        showWhen: (fieldValues) => {
          return fieldValues['fieldType'] === 'OtherField';
        },
        initialNumberOfLines: 5,
        dataType: 'string',
        name: 'dataType',
        placeholder: 'Choose Data Type',
        required: false,
        options: [
          {
            label: 'String',
            value: 'String',
          },
          {
            label: 'Boolean',
            value: 'Boolean',
          },
          {
            label: 'Date',
            value: 'Date',
          },
          {
            label: 'DateTime',
            value: 'DateTime',
          },
        ],
      },
    ],
  },
  'members-lifecycle': {
    label: 'Members Lifecycle Attributes',
    fields: [
      {
        label: 'Field Label',
        type: 'text',
        dataType: 'string',
        name: 'configLabel',
        placeholder: 'Enter Field Label',
        required: true,
      },
      {
        label: 'Field ID',
        type: 'text',
        dataType: 'string',
        name: 'fieldId',
        placeholder: 'Enter Field ID',
        required: true,
      },
      {
        label: 'Field Type',
        type: 'dropdown',
        dataType: 'string',
        name: 'fieldType',
        placeholder: 'Field Type',
        required: true,
        options: [
          { label: 'First Seen Date', value: 'FirstSeenDate' },

          { label: 'Other Field', value: 'OtherField' },
        ],
      },

      {
        label: 'Data Type',
        type: 'dropdown',
        isParagraph: true,
        showWhen: (fieldValues) => {
          return fieldValues['fieldType'] === 'OtherField';
        },
        initialNumberOfLines: 5,
        dataType: 'string',
        name: 'dataType',
        placeholder: 'Choose Data Type',
        required: false,
        options: [
          {
            label: 'String',
            value: 'String',
          },
          {
            label: 'Boolean',
            value: 'Boolean',
          },
          {
            label: 'Date',
            value: 'Date',
          },
          {
            label: 'DateTime',
            value: 'DateTime',
          },
        ],
      },
    ],
  },
  'basic-meta': {
    label: 'Basic Details Additional Fields',
    fields: [
      {
        label: 'Field Label',
        type: 'text',
        dataType: 'string',
        name: 'configLabel',
        placeholder: 'Enter Field Label',
        required: true,
      },
      {
        label: 'Field ID',
        type: 'text',
        dataType: 'string',
        name: 'fieldId',
        placeholder: 'Enter Field ID',
        required: true,
      },
      {
        label: 'Field Type',
        type: 'dropdown',
        dataType: 'string',
        name: 'fieldType',
        placeholder: 'Field Type',
        required: true,
        options: [
          { label: 'Text Field', value: 'text' },
          { label: 'Number Field', value: 'number' },
          { label: 'Textarea', value: 'textarea' },
          { label: 'Multi Select', value: 'multiSelect' },
          { label: 'Multi Select Checkbox', value: 'multiSelectCheckbox' },
          { label: 'Dropdown', value: 'select' },
          { label: 'Date & Time', value: 'datetime' },
          { label: 'Date', value: 'date' },
          { label: 'Single Select (Radio)', value: 'radio' },
          { label: 'Switch', value: 'switch' },
          { label: 'Other Field', value: 'OtherField' },
        ],
      },
      {
        label: 'Data Type',
        type: 'dropdown',
        isParagraph: true,
        showWhen: (fieldValues) => {
          return fieldValues['fieldType'] === 'OtherField';
        },
        initialNumberOfLines: 5,
        dataType: 'string',
        name: 'dataType',
        placeholder: 'Choose Data Type',
        required: false,
        options: [
          {
            label: 'String',
            value: 'String',
          },
          {
            label: 'Boolean',
            value: 'Boolean',
          },
          {
            label: 'Date',
            value: 'Date',
          },
          {
            label: 'DateTime',
            value: 'DateTime',
          },
        ],
      },
      {
        label: 'Is Required',
        type: 'dropdown',
        dataType: 'boolean',
        name: 'isRequired',
        placeholder: 'Is Required',
        required: false,
        options: [
          {
            label: 'No',
            value: false,
          },
          {
            label: 'Yes',
            value: true,
          },
        ],
      },
      {
        showWhen: (fieldValues) => {
          return (
            fieldValues['fieldType'] === 'select' ||
            fieldValues['fieldType'] === 'multiSelect' ||
            fieldValues['fieldType'] === 'multiSelectCheckbox' ||
            fieldValues['fieldType'] === 'radio' ||
            fieldValues['fieldType'] === 'checkbox'
          );
        },
        label: 'optionValues',
        type: 'optionValues',
        dataType: 'array',
        name: 'optionValues',
        placeholder: 'Option Values',
        required: false,
      },
      {
        label: 'Is Enable Locale',
        type: 'dropdown',
        dataType: 'boolean',
        name: 'isLocaleEnabled',
        placeholder: 'Is Enable Locale',
        required: true,
        options: [
          {
            label: 'No',
            value: false,
          },
          {
            label: 'Yes',
            value: true,
          },
        ],
      },
      {
        label: 'Choose Locales',
        type: 'multiSelect',
        dataType: 'string',
        name: 'locales',
        required: true,
        options: [
          { label: 'English', value: 'en' },
          { label: 'Arabic', value: 'ar' },
        ],
      },
    ],
  },
  'input-meta': {
    label: 'Messages Configuration',
    fields: [
      {
        label: 'Field Group',
        type: 'text',
        dataType: 'string',
        name: 'fieldGroup',
        placeholder: 'Field Group',
        required: true,
      },
      {
        label: 'Field Label',
        type: 'text',
        dataType: 'string',
        name: 'configLabel',
        placeholder: 'Enter Field Label',
        required: true,
      },
      {
        label: 'Field ID',
        type: 'text',
        dataType: 'string',
        name: 'fieldId',
        placeholder: 'Enter Field ID',
        required: true,
      },
      {
        label: 'Field Type',
        type: 'dropdown',
        dataType: 'string',
        name: 'fieldType',
        placeholder: 'Field Type',
        required: true,
        options: [
          { label: 'Text Field', value: 'text' },
          { label: 'Number Field', value: 'number' },
          { label: 'Textarea', value: 'textarea' },
          { label: 'Multi Select', value: 'multiSelect' },
          { label: 'Multi Select Checkbox', value: 'multiSelectCheckbox' },
          { label: 'Dropdown', value: 'select' },
          { label: 'Date & Time', value: 'datetime' },
          { label: 'Date', value: 'date' },
          { label: 'Single Select (Radio)', value: 'radio' },
          { label: 'Switch', value: 'switch' },
          { label: 'Other Field', value: 'OtherField' },
        ],
      },

      {
        label: 'Data Type',
        type: 'dropdown',
        isParagraph: true,
        showWhen: (fieldValues) => {
          return fieldValues['fieldType'] === 'OtherField';
        },
        initialNumberOfLines: 5,
        dataType: 'string',
        name: 'dataType',
        placeholder: 'Choose Data Type',
        required: false,
        options: [
          {
            label: 'String',
            value: 'String',
          },
          {
            label: 'Boolean',
            value: 'Boolean',
          },
          {
            label: 'Date',
            value: 'Date',
          },
          {
            label: 'DateTime',
            value: 'DateTime',
          },
        ],
      },
      {
        label: 'Is Required',
        type: 'dropdown',
        dataType: 'boolean',
        name: 'isRequired',
        placeholder: 'Is Required',
        required: false,
        options: [
          {
            label: 'No',
            value: false,
          },
          {
            label: 'Yes',
            value: true,
          },
        ],
      },
      {
        label: 'Is Enable Locale',
        type: 'dropdown',
        dataType: 'boolean',
        name: 'isLocaleEnabled',
        placeholder: 'Is Enable Locale',
        required: true,
        options: [
          {
            label: 'No',
            value: false,
          },
          {
            label: 'Yes',
            value: true,
          },
        ],
      },
      {
        label: 'Choose Locales',
        type: 'multiSelect',
        dataType: 'string',
        name: 'locales',
        required: true,
        options: [
          { label: 'English', value: 'en' },
          { label: 'Arabic', value: 'ar' },
        ],
      },
    ],
  },
  'output-meta': {
    label: 'Basic Details Meta Config',
    fields: [
      {
        label: 'Field Label',
        type: 'text',
        dataType: 'string',
        name: 'configLabel',
        placeholder: 'Enter Field Label',
        required: true,
      },
      {
        label: 'Field ID',
        type: 'text',
        dataType: 'string',
        name: 'fieldId',
        placeholder: 'Enter Field ID',
        required: true,
      },
      {
        label: 'Field Type',
        type: 'dropdown',
        dataType: 'string',
        name: 'fieldType',
        placeholder: 'Field Type',
        required: true,
        options: [
          { label: 'Text Field', value: 'text' },
          { label: 'Number Field', value: 'number' },
          { label: 'Textarea', value: 'textarea' },
          { label: 'Multi Select', value: 'multiSelect' },
          { label: 'Multi Select Checkbox', value: 'multiSelectCheckbox' },
          { label: 'Dropdown', value: 'select' },
          { label: 'Date & Time', value: 'datetime' },
          { label: 'Date', value: 'date' },
          { label: 'Single Select (Radio)', value: 'radio' },
          { label: 'Switch', value: 'switch' },
          { label: 'Other Field', value: 'OtherField' },
        ],
      },
      {
        label: 'Data Type',
        type: 'dropdown',
        isParagraph: true,
        showWhen: (fieldValues) => {
          return fieldValues['fieldType'] === 'OtherField';
        },
        initialNumberOfLines: 5,
        dataType: 'string',
        name: 'dataType',
        placeholder: 'Choose Data Type',
        required: false,
        options: [
          {
            label: 'String',
            value: 'String',
          },
          {
            label: 'Boolean',
            value: 'Boolean',
          },
          {
            label: 'Date',
            value: 'Date',
          },
          {
            label: 'DateTime',
            value: 'DateTime',
          },
        ],
      },
      {
        label: 'Is Required',
        type: 'dropdown',
        dataType: 'boolean',
        name: 'isRequired',
        placeholder: 'Is Required',
        required: false,
        options: [
          {
            label: 'No',
            value: false,
          },
          {
            label: 'Yes',
            value: true,
          },
        ],
      },
    ],
  },
  'milestone-schema': {
    label: 'Milestone Schema',
    fields: [
      {
        label: 'Field Label',
        type: 'text',
        dataType: 'string',
        name: 'configLabel',
        placeholder: 'Enter Field Label',
        required: true,
      },
      {
        label: 'Field ID',
        type: 'text',
        dataType: 'string',
        name: 'fieldId',
        placeholder: 'Enter Field ID',
        required: true,
      },
      {
        label: 'Field Type',
        type: 'dropdown',
        dataType: 'string',
        name: 'fieldType',
        placeholder: 'Field Type',
        required: true,
        options: [
          { label: 'Text Field', value: 'text' },
          { label: 'Number Field', value: 'number' },
          { label: 'Textarea', value: 'textarea' },
          { label: 'Multi Select', value: 'multiSelect' },
          { label: 'Multi Select Checkbox', value: 'multiSelectCheckbox' },
          { label: 'Dropdown', value: 'select' },
          { label: 'Date & Time', value: 'datetime' },
          { label: 'Date', value: 'date' },
          { label: 'Single Select (Radio)', value: 'radio' },
          { label: 'Switch', value: 'switch' },
          { label: 'Other Field', value: 'OtherField' },
        ],
      },
      {
        label: 'Data Type',
        type: 'dropdown',
        isParagraph: true,
        showWhen: (fieldValues) => {
          return fieldValues['fieldType'] === 'OtherField';
        },
        initialNumberOfLines: 5,
        dataType: 'string',
        name: 'dataType',
        placeholder: 'Choose Data Type',
        required: false,
        options: [
          {
            label: 'String',
            value: 'String',
          },
          {
            label: 'Boolean',
            value: 'Boolean',
          },
          {
            label: 'Date',
            value: 'Date',
          },
          {
            label: 'DateTime',
            value: 'DateTime',
          },
        ],
      },
      {
        label: 'Is Required',
        type: 'dropdown',
        dataType: 'boolean',
        name: 'isRequired',
        placeholder: 'Is Required',
        required: false,
        options: [
          {
            label: 'No',
            value: false,
          },
          {
            label: 'Yes',
            value: true,
          },
        ],
      },
    ],
  },
};

export const configTypesList = {
  members: ['configLabel', 'fieldId', 'fieldType', 'isPrimaryIdentifier'],
  'members-localization': [
    'configLabel',
    'fieldId',
    'fieldType',
    'isPrimaryIdentifier',
  ],
  'members-lifecycle': [
    'configLabel',
    'fieldId',
    'fieldType',
    'isPrimaryIdentifier',
  ],
  'basic-meta': [
    'configLabel',
    'fieldId',
    'fieldType',
    'isRequired',
    'isLocaleEnabled',
  ],
  'input-meta': [
    'fieldGroup',
    'configLabel',
    'fieldId',
    'fieldType',
    'isRequired',
    'isLocaleEnabled',
  ],
  'output-meta': ['configLabel', 'fieldId', 'fieldType', 'isRequired'],
  'milestone-schema': ['configLabel', 'fieldId', 'fieldType', 'isRequired'],
  languages: ['name', 'code', 'isDefault', 'isMandatoryForErrorMessages'],
  'basket-playground': ['configLabel', 'api-endpoint', 'api-method'],
  brands: ['configLabel', 'api-endpoint'],
};
const schema = {};
map(configTypes, (configType, key) => {
  schema[key] = {};

  configType.fields.forEach((field) => {
    schema[field.name] = Yup.string().required(`${field.name} is required`);
  });
});

export const validationSchema = schema;
